import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { GrantedOperationService } from '@/app/core/auth/granted-operation.service';
import { AppMenuitem } from './app.menuitem';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './app.menu.html'
})
/* v8 ignore start */
export class AppMenu implements OnInit {
/* v8 ignore stop */
    private readonly grantedOperations = inject(GrantedOperationService);
    model: any[] = applyGrantedOperations(menuModel(), new Set());

    ngOnInit(): void {
        void this.grantedOperations.ensureLoaded().then(() => {
            this.model = applyGrantedOperations(menuModel(), this.grantedOperations.granted());
        });
    }
}

function menuModel(): any[] {
    return [
        {
            label: 'Faturamento',
            icon: 'pi pi-receipt',
            path: '/faturamento',
            items: [
                {
                    label: 'Notas Fiscais',
                    icon: 'pi pi-fw pi-file-edit',
                    routerLink: ['/faturamento/notas-fiscais']
                },
                {
                    label: 'Nova Nota Fiscal',
                    icon: 'pi pi-fw pi-plus',
                    routerLink: ['/faturamento/notas-fiscais/nova']
                }
            ]
        },
        { separator: true },
        {
            label: 'Cadastros',
            icon: 'pi pi-box',
            path: '/cadastros',
            items: [
                {
                    label: 'Workspaces',
                    icon: 'pi pi-fw pi-th-large',
                    routerLink: ['/cadastros/workspaces']
                },
                {
                    label: 'Empresas',
                    icon: 'pi pi-fw pi-building',
                    routerLink: ['/cadastros/empresas']
                },
                {
                    label: 'Clientes',
                    icon: 'pi pi-fw pi-users',
                    routerLink: ['/cadastros/clientes']
                },
                {
                    label: 'Produtos',
                    icon: 'pi pi-fw pi-box',
                    routerLink: ['/cadastros/produtos']
                },
                {
                    label: 'Categorias',
                    icon: 'pi pi-fw pi-sitemap',
                    routerLink: ['/cadastros/categorias-de-produto']
                },
                {
                    label: 'Marcas',
                    icon: 'pi pi-fw pi-tag',
                    routerLink: ['/cadastros/marcas']
                },
                {
                    label: 'Unidades do Produto',
                    icon: 'pi pi-fw pi-objects-column',
                    routerLink: ['/cadastros/unidades-de-produto']
                },
                {
                    label: 'Grupos Fiscais',
                    icon: 'pi pi-fw pi-percentage',
                    routerLink: ['/cadastros/grupos-fiscais']
                },
                {
                    label: 'Classificações Fiscais',
                    icon: 'pi pi-fw pi-book',
                    routerLink: ['/cadastros/classificacoes-fiscais']
                },
                {
                    label: 'Tabelas de Preço',
                    icon: 'pi pi-fw pi-list',
                    routerLink: ['/cadastros/tabelas-de-preco']
                },
                {
                    label: 'Preços de Produto',
                    icon: 'pi pi-fw pi-dollar',
                    routerLink: ['/cadastros/precos-de-produto']
                }
            ]
        },
        { separator: true },
        {
            label: 'Backoffice Global',
            icon: 'pi pi-globe',
            path: '/backoffice-global',
            items: [
                {
                    label: 'Localidades',
                    icon: 'pi pi-fw pi-map',
                    path: '/configuracoes/localidades',
                    items: [
                        {
                            label: 'Países',
                            icon: 'pi pi-fw pi-globe',
                            routerLink: ['/configuracoes/paises']
                        },
                        {
                            label: 'Estados',
                            icon: 'pi pi-fw pi-map-marker',
                            routerLink: ['/configuracoes/unidades-federativas']
                        },
                        {
                            label: 'Municípios',
                            icon: 'pi pi-fw pi-building',
                            routerLink: ['/configuracoes/municipios']
                        },
                        {
                            label: 'Cidades',
                            icon: 'pi pi-fw pi-map',
                            routerLink: ['/configuracoes/cidades']
                        },
                        {
                            label: 'Logradouros',
                            icon: 'pi pi-fw pi-compass',
                            routerLink: ['/configuracoes/logradouros']
                        }
                    ]
                },
                {
                    label: 'CFOP',
                    icon: 'pi pi-fw pi-receipt',
                    path: '/configuracoes/cfop-menu',
                    items: [
                        {
                            label: 'CFOP',
                            icon: 'pi pi-fw pi-receipt',
                            routerLink: ['/configuracoes/cfop']
                        },
                        {
                            label: 'Grupos de CFOP',
                            icon: 'pi pi-fw pi-folder',
                            routerLink: ['/configuracoes/grupos-cfop']
                        }
                    ]
                },
                {
                    label: 'NCM',
                    icon: 'pi pi-fw pi-tags',
                    path: '/cadastros/ncm-menu',
                    items: [
                        {
                            label: 'Códigos NCM',
                            icon: 'pi pi-fw pi-sitemap',
                            routerLink: ['/cadastros/ncm']
                        },
                        {
                            label: 'Seções NCM',
                            icon: 'pi pi-fw pi-th-large',
                            routerLink: ['/cadastros/secoes-ncm']
                        }
                    ]
                },
                {
                    label: 'CNAE',
                    icon: 'pi pi-fw pi-sitemap',
                    path: '/configuracoes/cnae',
                    items: [
                        {
                            label: 'Seções',
                            icon: 'pi pi-fw pi-bookmark',
                            routerLink: ['/configuracoes/cnae/secoes']
                        },
                        {
                            label: 'Divisões',
                            icon: 'pi pi-fw pi-table',
                            routerLink: ['/configuracoes/cnae/divisoes']
                        },
                        {
                            label: 'Grupos',
                            icon: 'pi pi-fw pi-folder',
                            routerLink: ['/configuracoes/cnae/grupos']
                        },
                        {
                            label: 'Classes',
                            icon: 'pi pi-fw pi-list',
                            routerLink: ['/configuracoes/cnae/classes']
                        },
                        {
                            label: 'Subclasses',
                            icon: 'pi pi-fw pi-tags',
                            routerLink: ['/configuracoes/cnae/subclasses']
                        }
                    ]
                },
                {
                    label: 'Unidades de Medida',
                    icon: 'pi pi-fw pi-calculator',
                    routerLink: ['/cadastros/unidades-de-medida']
                },
                {
                    label: 'Segmentos de Negócio',
                    icon: 'pi pi-fw pi-briefcase',
                    routerLink: ['/configuracoes/segmentos-de-negocio']
                },
                {
                    label: 'Permissões',
                    icon: 'pi pi-fw pi-lock',
                    path: '/configuracoes/permissoes',
                    items: [
                        {
                            label: 'Operações',
                            icon: 'pi pi-fw pi-key',
                            operation: 'authorization_operation:list',
                            routerLink: ['/configuracoes/permissoes/operacoes']
                        },
                        {
                            label: 'Funcionalidades',
                            icon: 'pi pi-fw pi-bolt',
                            operation: 'authorization_feature:list',
                            routerLink: ['/configuracoes/permissoes/funcionalidades']
                        },
                        {
                            label: 'Perfis',
                            icon: 'pi pi-fw pi-id-card',
                            operation: 'authorization_profile:list',
                            routerLink: ['/configuracoes/permissoes/perfis']
                        },
                        {
                            label: 'Grupos',
                            icon: 'pi pi-fw pi-users',
                            operation: 'authorization_group:list',
                            routerLink: ['/configuracoes/permissoes/grupos']
                        },
                        {
                            label: 'Usuários',
                            icon: 'pi pi-fw pi-user',
                            operation: 'authorization_account:list',
                            routerLink: ['/configuracoes/permissoes/usuarios']
                        }
                    ]
                }
            ]
        }
    ];
}

function applyGrantedOperations(items: any[], granted: ReadonlySet<string>): any[] {
    return items.map((item) => {
        if (!item.items) {
            if (!item.operation) {
                return item;
            }
            return { ...item, visible: granted.has(item.operation) };
        }
        const children = applyGrantedOperations(item.items, granted);
        const visibleChild = children.some((child) => child.visible !== false && !child.separator);
        return { ...item, items: children, visible: visibleChild };
    });
}
